import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralService } from '../../../services/general/general.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss'],
})
export class RecoverPasswordComponent implements OnInit {
  // we create form variable
  public form: FormGroup;

  public loading = false;

  constructor(
    private formBuilder: FormBuilder,
    public general: GeneralService
  ) {
    // We create form
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  async ngOnInit() {}

  // We check email is valid
  get emailNoValido() {
    return this.form.get('email')?.invalid && this.form.get('email')?.touched;
  }

  //We call service for Login
  async sendEmail() {
    try {
      this.loading = true;
      const response = await this.general.httpPost(
        'forgot-pass-send-mail',
        this.form.value
      );
      await this.general.showSuccess('email-sent-successfully');
      await this.general.navigate('auth/login');
    } catch (error: any) {
      await this.general.showErrorForm(error);
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
}
